/* eslint-disable no-unused-vars */
import {
  GET_COURSEOUTLINE,
  GET_COURSEOUTLINES,
  GET_COURSEOUTLINES_DDL,
  GET_COURSEOUTLINES_BY_FILTER,
  ADD_COURSEOUTLINE,
  UPDATE_COURSEOUTLINE,
  DELETE_COURSEOUTLINE
} from '@/queries/modules/courses/course-outline.js';

import {apolloClient} from '@/setup/apollo-setup';
import {getField, updateField} from 'vuex-map-fields';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';

// TODO: Replace with Apollo Client
import { getCourseOutlineById } from "@/services/api/course-outline";

//
// initial state
const state = {
  courseOutline: {
    id: '',
    subjectCode: '',
    teacherCode: '',
    totalPoint: null,
    instruction: '',
    streamIntroPath: '',
    bookName1:        '',
    bookPic1:         '',
    bookDescription1: '',
    bookName2:        '',
    bookPic2:         '',
    bookDescription2: '',
    bookName3:        '',
    bookPic3:         '',
    bookDescription3:  '',
    degreeId: '',
    subjectGroupId: '',
    subjectId: '',
    teacherId: '',
    courseOutlineUnits: [],
    courseOutlineAssessments: [],
    vdoSets: [],
  },
  courseOutlines: [],
  courseOutlinesDDL: [],
  processing: false,
  error: null,
  success: null,
};

//
// getters
const getters = {
  getField
};

//
// mutations
const mutations = {
  updateField,
  clearError: (state) => {
    state.error = null;
  },
  setError: (state, payload) => {
    state.error = payload;
    state.success = null;
    state.processing = false;
  },
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: (state, payload) => {
    state.processing = payload;
  },
  setCourseOutlines: (state, payload) => {
    state.courseOutlines = payload ? payload : [];
  },
  setCourseOutlinesDDL: (state, payload) => {
    state.courseOutlinesDDL = payload ? payload : [];
  },
  setCourseOutline: (state, payload) => {
    state.courseOutline = payload;
  },
  setSelectedCourseOutline: (state, payload) => {
    state.courseOutline = {...payload};
  },
  clearSelectedCourseOutline: (state) => {
    state.courseOutline = {
      id: '',
      subjectCode: '',
      teacherCode: '',
      totalPoint: null,
      instruction: '',
      streamIntroPath: '',
      bookName1:        '',
      bookPic1:         '',
      bookDescription1: '',
      bookName2:        '',
      bookPic2:         '',
      bookDescription2: '',
      bookName3:        '',
      bookPic3:         '',
      bookDescription3:  '',
      degreeId: '',
      subjectGroupId: '',
      subjectId: '',
      teacherId: '',
      courseOutlineUnits: [],
      courseOutlineAssessments: [],
      vdoSets: [],
    }
  }
};

//
// actions
const actions = {
  getCourseOutline: async ({commit}, id) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_COURSEOUTLINE,
        variables: {
          id: id
        }
      })
      .then(({data}) => {
        commit('setCourseOutline', data.getCourseOutline);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  getCourseOutlines: async ({commit}, useState = true) => {
    commit('setProcessing', true);

    try {
      const result = await apolloClient
        .query({
          query: GET_COURSEOUTLINES,
          fetchPolicy: 'network-only'
        });

      const { data, errors } = await result;

      if (errors) {
        commit('setError', error(errors));
        return state.courseOutlines;
      }else{
        if(useState){
          commit('setCourseOutlines', data.getCourseOutlines);
        }
        commit('setSuccess', null);
        return data.getCourseOutlines
      }

    } catch (e) {
      commit('setError', error(e));
      return state.courseOutlines;
    }
  },
  getCourseOutlinesDDL: async ({commit}, useState = true) => {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_COURSEOUTLINES_DDL,
          fetchPolicy: 'network-only'
        });

      const { data, errors } = await result;

      if (errors) {
        commit('setError', error(errors));
        return state.courseOutlinesDDL;
      }else{
        if(useState){
          commit('setCourseOutlinesDDL', data.getCourseOutlines);
        }
        commit('setSuccess', null);
        return data.getCourseOutlines
      }

    } catch (e) {
      commit('setError', error(e));
      return state.courseOutlinesDDL;
    }
  },
  getCourseOutlinesByFilter: async ({commit}, payload, useState = true) => {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_COURSEOUTLINES_BY_FILTER,
          variables: payload,
          fetchPolicy: 'network-only'
        });

      const { data, errors } = await result;

      if (errors) {
        commit('setError', error(errors));
        return state.courseOutlines;
      }else{
        if(useState){
          commit('setCourseOutlines', data.getCourseOutlinesByFilter);
        }
        commit('setSuccess', null);
        return data.getCourseOutlinesByFilter
      }

    } catch (e) {
      commit('setError', error(e));
      return state.courseOutlines;
    }
  },
  addCourseOutline: async ({commit}, payload, useState = true) => {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .mutate({
          mutation: ADD_COURSEOUTLINE,
          variables: payload,
        });

      const {data, errors} = await result;

      if (errors) {
        commit('setError', error(errors));
        return null;
      } else {

        if (useState) {
          const courseOutlines = [...state.courseOutlines];
          courseOutlines.push(data.addCourseOutline);
          commit('setCourseOutlines', courseOutlines);
        }

        commit('setSuccess', newItemSuccess(data.addCourseOutline.subject.nameLocal));
        return data.addCourseOutline
      }

    } catch (e) {
      commit('setError', error(e));
      return null;
    }

  },
  updateCourseOutline: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: UPDATE_COURSEOUTLINE,
        variables: payload
      })
      .then(({data}) => {
        const index = state.courseOutlines.findIndex(courseOutline => courseOutline.id === data.updateCourseOutline.id);
        const courseOutlines = [
          ...state.courseOutlines.slice(0, index),
          data.updateCourseOutline,
          ...state.courseOutlines.slice(index + 1)
        ];

        commit('setCourseOutlines', courseOutlines);
        commit('setSuccess', updateItemSuccess(data.updateCourseOutline.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  deleteCourseOutline: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: DELETE_COURSEOUTLINE,
        variables: payload
      })
      .then(({data}) => {
        const index = state.courseOutlines.findIndex(courseOutline => courseOutline.id === data.deleteCourseOutline.id);
        const courseOutlines = [
          ...state.courseOutlines.slice(0, index),
          ...state.courseOutlines.slice(index + 1)
        ];

        commit('setCourseOutlines', courseOutlines);
        commit('setSuccess', deleteItemSuccess(data.deleteCourseOutline.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  selectedCourseOutline: async ({commit}, payload) => {
    commit('setSelectedCourseOutline', payload);
  },
  clearSelectedCourseOutline: async ({commit}) => {
    commit('clearSelectedCourseOutline');
  },

  async getCourseOutlineById({commit}, payload) {
    try {
      const data = await getCourseOutlineById(payload);
      // TODO: Handle after success;
      return data;
    } catch (e) {
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }}
    }
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
